// Header Component
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {SurveyModalProps} from '../SurveyModal.component';
import Translate from '../../../components/translate/Translate';
import React from 'react';

@observer
export class SurveyModalHeader extends TechseeBaseComponent<SurveyModalProps> {
    renderInternal(): JSX.Element {
        const {ctrl} = this.props;

        return ctrl.failure ? <SurveyModalHeaderFailure ctrl={ctrl} /> : <SurveyModalHeaderSuccess ctrl={ctrl} />;
    }
}

@observer
class SurveyModalHeaderFailure extends TechseeBaseComponent<SurveyModalProps> {
    renderInternal(): JSX.Element {
        const {ctrl} = this.props;

        return (
            <div className='sub-modal-header' dir={ctrl.dir}>
                <img src={ctrl.requireImage('sad-smile-icon.png')} alt='' />
                <h5 className='modal-title inline-block'>
                    <Translate text='DASHBOARD.SURVEY.FAILURE_TITLE' />
                </h5>
                <p className='modal-subtitle'>
                    <Translate text='DASHBOARD.SURVEY.FAILURE_SUBTITLE1' />
                </p>
                <br />
                <p className='modal-subtitle'>
                    <Translate text='DASHBOARD.SURVEY.FAILURE_SUBTITLE2' />
                </p>
            </div>
        );
    }
}

@observer
class SurveyModalHeaderSuccess extends TechseeBaseComponent<SurveyModalProps> {
    renderInternal(): JSX.Element {
        const {ctrl} = this.props;

        return (
            <div className='sub-modal-header' dir={ctrl.dir}>
                <img src={ctrl.requireImage('bubble.png')} alt='' />
                <p className='modal-subtitle'>
                    <Translate text='DASHBOARD.SURVEY.QUALITY_SUBTITLE' />
                </p>
            </div>
        );
    }
}
